export default __webpack_public_path__ + "static/media/vraj@4x.ace302ef.png";